/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormDateTimeField, {
  FormDateTimeFieldProps
} from '../../../../client/js/components/form/fields/FormDatetimeField'

function EndDateField (props: FormDateTimeFieldProps) {
  const { name = 'endDate', ...others } = props
  const intl = useIntl()
  return (
    <FormDateTimeField
      label={intl.formatMessage({
        id: 'end_date',
        defaultMessage: 'Date de fin'
      })}
      name={name}
      {...others}
    />
  )
}

export default EndDateField
